/*
 * @Descripttion: vant组件
 * @version: V1.0
 * @Author: yuanxing(01407381)
 * @Date: 2022-06-20 15:56:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-12-12 21:08:25
 */
import Vue from 'vue'
import {
  Tab,
  Tabs,
  Popup,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  DatetimePicker,
  Stepper,
  Switch,
  Field,
  IndexBar,
  IndexAnchor,
  Form,
  Search,
  Toast,
  Button,
  Dialog,
  List,
  NoticeBar,
  ActionSheet,
  Tag,
  Uploader,
  Swipe,
  SwipeItem,
  ImagePreview,
  Overlay,
  Loading,
  Popover,
  Locale,
  Collapse,
  CollapseItem,
} from 'vant'

// 动态导入Vant语言包
const loadLocale = (locale) => {
  try {
    switch (locale) {
      case 'zh-CN':
        return import('vant/es/locale/lang/zh-CN')
      case 'en-US':
        return import('vant/es/locale/lang/en-US')
      case 'ja-JP':
        return import('vant/es/locale/lang/ja-JP')
      case 'th-TH':
        return import('vant/es/locale/lang/th-TH')
      case 'vi-VN':
        return import('vant/es/locale/lang/vi-VN')
      // case 'ko-KR':
      //   return import('vant/es/locale/lang/ko-KR') // 暂时不支持
      case 'zh-TW':
        return import('vant/es/locale/lang/zh-TW')
      default:
        return import('vant/es/locale/lang/en-US')
    }
  } catch (error) {
    console.warn('Failed to load Vant locale:', locale, error)
    return Promise.resolve(null)
  }
}

const components = [
  Tab,
  Tabs,
  Popup,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  DatetimePicker,
  Stepper,
  Switch,
  Field,
  IndexBar,
  IndexAnchor,
  Form,
  Search,
  Toast,
  Button,
  Dialog,
  List,
  NoticeBar,
  ActionSheet,
  Tag,
  Uploader,
  Swipe,
  SwipeItem,
  ImagePreview,
  Overlay,
  Loading,
  Popover,
  Collapse,
  CollapseItem,
]

export default async (ctx, inject) => {
  if (!Vue.useVant) {
    components.forEach((component) => Vue.use(component))
    
    // 初始化Vant语言包
    const currentLocale = ctx.store.state.locale
    if (currentLocale) {
      const localeModule = await loadLocale(currentLocale)
      if (localeModule && localeModule.default) {
        Locale.use(currentLocale, localeModule.default)
      }
    }
    
    Vue.useVant = true
  }

  // 监听语言变化并更新Vant语言包
  if (process.client) {
    ctx.store.watch(
      (state) => state.locale,
      async (newLocale) => {
        if (newLocale) {
          const localeModule = await loadLocale(newLocale)
          if (localeModule && localeModule.default) {
            Locale.use(newLocale, localeModule.default)
          }
        }
      }
    )
  }
  Vue.useAnt = true
}
